// Dutch language
export default {
  actions:{
    buy:'Kopen',
    cancel:'Annuleren',
    book:'Boeken',
    reserve: 'Reserveren',
    download: 'Downloaden' //
  },
  label:{
    price:'Prijs',
    afterDiscount:'Na korting',
    color:'Kleur',
    qty:'Aantal',
    desc:'Beschrijving',
    speci:'Specificaties',
    video:'Bekijk volledige video',
    readmore:'Toon meer',
    showless:'Toon minder',
    choose:'Kies hieronder:',
    submit:'Indienen',
    deliverTime:'Kies levertijd',
    selectArea:'Selecteer Gebied',
    selectCity:'Selecteer Stad',
    select:'Selecteer'
  },
  images:{
    noImages:'Geen afbeeldingen'
  },
  tableLabels:{
    ar: [
      {
        key: "name",
        label: "Specificaties"
      },
      {
        key: "value",
        label: ""
      }
    ],
  },
  orderCart: {
    label: "Bestelling bewerken",
    remove: "Verwijderen",
    increase: "+",
    decrease: "-",
    addProduct: "Voeg item toe",
    confirm: "Afrekenen",
    cancel:"Sluiten",
    subtotal: "Subtotaal",
    tax: "Belasting",
    delivery: "Bezorgkosten",
    total: "Totaal",
    discount: "Korting",
    note: "Notities:",
    empty_order: "Je winkelwagen is leeg!",
    zero: 0.00,
    edit:'Bewerken',
    delete:'Verwijderen',
    noItem:'0 items in je winkelwagen',
    browsing:'Begin met browsen'
  },
  notify:{
    errorInput:"Er is iets misgegaan, alle velden moeten worden ingevuld",
    confirmErr:"Er is iets misgegaan, je hebt nog niets toegevoegd",
    error:"Er is iets misgegaan",
    emptyList:"Je winkelwagen is leeg!",
    largeFile: "Bestand is te groot!",
    maxSize: "Maximale grootte is",
    support: "bestand wordt niet ondersteund!",
    uploadError : "Bestand kon om een of andere reden niet worden geüpload, probeer het opnieuw.",
    multiFilesUpload: "Kan niet meer uploaden ",
    multiFiles: " bestanden tegelijk!",
    noInternet : "Geen internetverbinding, probeer het opnieuw!"
  },
  placeHolder:{
    input:"Voer in ",
    messageInput: "Typ een bericht ..."
  },
  captureLead:{
    phoneValidation:'Ongeldig telefoonnummer',
    emailValidation: 'Ongeldige e-mail',
    hello: "Hallo daar!"
  },
  footer: { 
    poweredBy: "Aangedreven door"
  },
  chatBody: {
    typingIndicator: "Bot is aan het nadenken...",
  }
};
